import { render, staticRenderFns } from "./list-skeleton.vue?vue&type=template&id=7d888281&scoped=true"
import script from "./list-skeleton.vue?vue&type=script&lang=js"
export * from "./list-skeleton.vue?vue&type=script&lang=js"
import style0 from "./list-skeleton.vue?vue&type=style&index=0&id=7d888281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d888281",
  null
  
)

export default component.exports